import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { useEffect, useState } from 'react';
import { modificaDetalleHorario } from '../../services/HorarioTurno/TurnoService';
import { useContextAdminHora } from './ContextAdminHorario';

const EditaDetalle = ({ horarioDetalle, ocultaDialogEditDetalle }) => {

  const { horarioDetalleId, horaFin, horaInicio } = horarioDetalle

  const [horaDIni, setHoraDIni] = useState();
  const [horaDFin, setHoraDFin] = useState();
  const [inhabilita, setInhabilita] = useState(false)

  const showToast = useContextAdminHora()

  useEffect( () => {
    const fecha = new Date()
    fecha.setHours(horaInicio.hour)
    fecha.setMinutes(horaInicio.minute)
    fecha.setSeconds(horaInicio.second)
    setHoraDIni(fecha)
    const fecha2 = new Date()
    fecha2.setHours(horaFin.hour)
    fecha2.setMinutes(horaFin.minute)
    fecha2.setSeconds(horaFin.second)
    setHoraDFin(fecha2)
  }, [])

  const formatHora = (fechaHora) => {
        if (!fechaHora) return '';

        const hora = String(fechaHora.getHours()).padStart(2, '0');
        const minuto = String(fechaHora.getMinutes()).padStart(2, '0');

        return `${hora}:${minuto}:00`;
    };

  const haceModifica = async () =>{
    const objDatoEnv = {
      horarioDetalleId: horarioDetalleId,
      horaInicio: formatHora(horaDIni),
      horaFin: formatHora(horaDFin)
    }
    setInhabilita(true)

    try {
      const response = await modificaDetalleHorario(objDatoEnv)
      showToast('success', 'Success', 'Horario creado con exito')
    } catch (error) {
      showToast('error', 'Error', 'Se ha producido un Error al modificar')
    } finally {
      ocultaDialogEditDetalle()
      setInhabilita(false)
    }
  }

    return (
        <div className="card">
            <h5>Edicion de horario</h5>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Hora Inicio:</label>
                    <Calendar value={horaDIni} onChange={(e) => setHoraDIni(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Hora Fin:</label>
                    <Calendar value={horaDFin} onChange={(e) => setHoraDFin(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                <div className="field col-12 md:col-6">
                    <div className="flex justify-center gap-5">
                        <Button label="Cancelar" style={{ width: '100px' }} onClick={ocultaDialogEditDetalle} disabled={inhabilita} />
                        <Button label="Cambiar" style={{ width: '100px' }} onClick={haceModifica} disabled={inhabilita} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditaDetalle;
